import AirIcon from "@mui/icons-material/Air";
import ApartmentIcon from "@mui/icons-material/Apartment";
import BoltIcon from "@mui/icons-material/Bolt";
import CircleIcon from "@mui/icons-material/Circle";
import ForestIcon from "@mui/icons-material/Forest";
import MovingIcon from "@mui/icons-material/Moving";
import RadarIcon from "@mui/icons-material/Radar";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import TableRowsIcon from "@mui/icons-material/TableRows";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import { AiOutlineSound } from "react-icons/ai";
import { Chip } from "@mui/material";
import React from "react";
import { MdRollerShades } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { deselectDaylight } from "../redux/daylightFactor";
import { setDefaultFloor } from "../redux/floorVisibility";
import { deselectPVData } from "../redux/pvData";
import { deselectEnergyData } from "../redux/roomData";
import { selectAllSurrounding, setDefaultTarget } from "../redux/sceneSlice";
import {
  deselectSensorPosition,
  deselectShadingProgression,
  deselectWindAlarmSensors,
  deselectWindRisk,
} from "../redux/shadingSystem";
import { setDefaultVirtualSensors } from "../redux/solarSensors";
import { deselectWindSensors } from "../redux/windDirection";
import {
  useResetAllFilters,
  useSensorPlacementColorBar,
  useActiveWindAlarmScenario,
} from "./CustomHooks";
import { hideSoundEmission } from "../redux/soundEmission";

const Filter = () => {
  var dispatch = useDispatch();
  var daylightSelector = useSelector((state) => state.daylightFactor.value);
  var roomDataSelector = useSelector((state) => state.roomData.value);
  var windSelector = useSelector((state) => state.windDirection.value);
  const sensorsSelector = useSelector((store) => store.sensorSolars.value);
  var windRiskSelector = useSelector(
    (state) => state.shadingSystem.value.checkStatus,
  );
  const surroundingVisibility = useSelector(
    (state) => state.sceneVisibility.surroundingValue,
  );
  const floorVisibility = useSelector(
    (state) => state.floorVisibility.selectedFloors,
  );
  var targetScene = useSelector((state) => state.sceneVisibility);
  var shadingDemandSelector = useSelector((state) => state.shadingSystem.value);

  const { filter } = useSelector((state) => state.pvData);
  const { sensorCandidatesVisible, windAlarmSensorsVisible } =
    useSensorPlacementColorBar();
  const activeWindAlarmScenario = useActiveWindAlarmScenario();
  const soundEmissionVisible = useSelector(
    (state) => state.soundEmission.isVisible,
  );

  const { resetFilters: handleClick } = useResetAllFilters();

  const chips = [
    {
      label: "Target Building",
      onDelete: () => dispatch(setDefaultTarget()),
      icon: <ApartmentIcon />,
      isVisible:
        targetScene.value.some((e) => !e) &&
        targetScene.value?.some((e, i) => e !== targetScene.default[i]),
      deleteIcon: <RestartAltIcon />,
      color: "error",
    },
    {
      label: "Surrounding",
      onDelete: () => dispatch(selectAllSurrounding()),
      icon: <ForestIcon />,
      isVisible: surroundingVisibility?.some((e) => !e),
      deleteIcon: <RestartAltIcon />,
      color: "error",
    },
    {
      label: "Floors",
      onDelete: () => dispatch(setDefaultFloor()),
      icon: <TableRowsIcon />,
      isVisible: floorVisibility?.some((e) => !e),
      deleteIcon: <RestartAltIcon />,
      color: "error",
    },

    {
      label: "Solar Sensors",
      onDelete: () => dispatch(setDefaultVirtualSensors()),
      icon: <CircleIcon />,
      isVisible: sensorsSelector?.checkStatus?.some((e) => e),
      color: "error",
    },
    {
      label: "Wind Sensors",
      onDelete: () => dispatch(deselectWindSensors()),
      icon: <MovingIcon />,
      isVisible: windSelector.checkStatus.some((e) => e),
      color: "error",
    },
    {
      label: "Sound Emission",
      onDelete: () => dispatch(hideSoundEmission()),
      icon: <AiOutlineSound size="1.5rem" />,
      isVisible: soundEmissionVisible,
      color: "error",
    },
    {
      label: "Wind Risk",
      onDelete: () => dispatch(deselectWindRisk()),
      icon: <AirIcon />,
      isVisible: windRiskSelector[0],
      color: "error",
    },
    {
      label: "Sensor candidates",
      onDelete: () => dispatch(deselectSensorPosition()),
      icon: <RadarIcon />,
      isVisible: sensorCandidatesVisible,
      color: "error",
    },
    {
      label: activeWindAlarmScenario
        ? `Wind alarm | ${activeWindAlarmScenario}`
        : "Wind alarm",
      onDelete: () => dispatch(deselectWindAlarmSensors()),
      icon: <RadarIcon />,
      isVisible: windAlarmSensorsVisible,
      color: "error",
    },
    {
      label: "Energy Data",
      onDelete: () => dispatch(deselectEnergyData()),
      icon: <BoltIcon />,
      isVisible:
        roomDataSelector?.parentName &&
        roomDataSelector?.childName !== undefined,
      color: "error",
    },

    {
      label: "Daylight Factor",
      onDelete: () => dispatch(deselectDaylight()),
      icon: <WbSunnyIcon />,
      isVisible:
        daylightSelector?.parentName &&
        daylightSelector?.childName !== undefined,
      color: "error",
    },
    {
      label: "PV Yield",
      onDelete: () => dispatch(deselectPVData()),
      icon: <SolarPowerIcon />,
      isVisible: Object.values(filter)?.some((e) => e),
      color: "error",
    },
    {
      label: "Shading Progression",
      onDelete: () => dispatch(deselectShadingProgression()),
      icon: <MdRollerShades size="1.5rem" />,
      isVisible: shadingDemandSelector.checkStatus[2],
      color: "error",
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "8px 12px",
        padding: "4px 10px 8px",
        zIndex: 10,
      }}
    >
      <button
        style={{
          border: "1px solid #d33",
          color: "#d33",
          borderRadius: "7px",
          width: "148px",
          height: "40px",
          alignItems: "center",
          padding: "4px",
          background: "#FFFFFF",
          cursor: "pointer",
          flexShrink: 0,
        }}
        onClick={handleClick}
      >
        Reset Filters
      </button>
      {chips.map((chip, index) => {
        if (chip.isVisible)
          return (
            <Chip
              key={index}
              label={chip.label}
              icon={chip.icon}
              variant="outlined"
              onDelete={chip.onDelete}
              deleteIcon={chip.deleteIcon}
              color={chip.color}
              sx={{ background: "white" }}
            />
          );
        return null;
      })}
      {shadingDemandSelector.checkStatus[2] && (
        <div
          style={{
            width: "220px",
            border: "1px solid #eee",
            borderRadius: "8px",
            backgroundColor: "white",
            padding: "4px 12px",
            height: "48px",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "4px",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: 12,
                height: 6,
                backgroundColor: "#182b42",
                borderRadius: 4,
              }}
            />
            <p>Shading System active</p>
          </div>
          <div
            style={{
              display: "flex",
              gap: "4px",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: 12,
                height: 6,
                backgroundColor: "#68bdfc",
                borderRadius: 4,
              }}
            />
            <p>Shading System not active</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Filter;
